module.exports = __webpack_public_path__ + "img/13.19c4bca4.jpg";